module.exports = __webpack_public_path__ + "static/media/milkProducts.232b90f0.webp";